import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '@/services/firebase';
import { ServiceStatusDoc } from '@/types';

/**
 * Public health aggregate, readable without signing in.
 *
 * The error feed lives on `errors`, which Firestore restricts to admins — so
 * service health could never render for a visitor. `serviceStatus` carries
 * occurrence timestamps and severities only, which is all the cards need.
 */
export function useServiceStatus() {
  const [aggregates, setAggregates] = useState<ServiceStatusDoc[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, 'serviceStatus'),
      (snapshot) => {
        setAggregates(
          snapshot.docs.map((doc) => ({
            service: doc.id,
            ...doc.data(),
          })) as ServiceStatusDoc[]
        );
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching service status:', err);
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { aggregates, loading, error };
}
